import { render, staticRenderFns } from "./InsuranceAuthorizationRecipe.vue?vue&type=template&id=0cb937a7&scoped=true&"
import script from "./InsuranceAuthorizationRecipe.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationRecipe.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAuthorizationRecipe.vue?vue&type=style&index=0&id=0cb937a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb937a7",
  null
  
)

export default component.exports